const fonts = require.context('../fonts', true)
const fontPath = (name) => fonts(name, true)